import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { db } from "../../firebase";
import { Alert, Snackbar } from "@mui/material";
import { addDoc, collection } from "firebase/firestore";
import AddIcon from "@mui/icons-material/Add";
import { useSnackbar } from "notistack";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

export default function CategoryModal() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const categoryRef = collection(db, "heading");
  const { enqueueSnackbar } = useSnackbar();

  const [values, setValues] = React.useState({
    name: "",
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  // set category
  const setDocData = () => {
    // Add a new document with a generated id.
    addDoc(categoryRef, values).then(() => {
      setOpen(false);
      enqueueSnackbar("Category Added!", { variant: "success" });
    });
  };

  return (
    <div>
      <div>
        <Button
          onClick={handleOpen}
          variant="contained"
          startIcon={<AddIcon />}
          disableElevation
          sx={{ width: 300, height: 40, borderRadius: 1 }}
        >
          Top Category
        </Button>
      </div>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Typography
              id="transition-modal-title"
              variant="h6"
              component="h2"
              sx={{ mb: 3 }}
            >
              Add Top Category
            </Typography>

            <div>
              <TextField
                className="inputRounded"
                sx={{ mb: 4, width: "100%" }}
                label="Category Name"
                type="text"
                variant="outlined"
                onChange={handleChange("name")}
              />
            </div>

            <Button
              onClick={setDocData}
              variant="contained"
              disableElevation
              sx={{ width: "100%", height: 50, borderRadius: 2 }}
            >
              Submit
            </Button>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
